// @flow
import * as React from "react"

type Props = {
  icon: React.ComponentType,
}

export default ({ icon: Icon, ...props }: Props) => <Icon {...props} />
